import React from 'react';
import { VirtualWaitingRoomState } from '../models/virtualWaitingRoom';
import { Call } from '../models/call';
import IncomingCall from './IncomingCall';
import JoinVWRCallModal from './JoinVWRCallModal';

export default function CallModal({
  call,
  virtualWaitingRoom,
}: {
  call?: Call;
  virtualWaitingRoom?: VirtualWaitingRoomState;
}) {
  if (call?.incomingCall !== undefined) {
    return <IncomingCall callEvent={call.incomingCall} />;
  } else if (virtualWaitingRoom?.incomingCall !== undefined) {
    return <JoinVWRCallModal callEvent={virtualWaitingRoom.incomingCall} />;
  }
  return <></>;
}
